import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import { useDispatch, useSelector } from 'react-redux'
export const initialState = {
  isOpened: false,
  isConfirmed: false,
  isDeclined: false,
  title: 'Confirm',
  message: 'Are you sure to confirm your changes ?',
  isInput: false,
  inputLabel: '',
  inputValue: '',
}

const confirmationModalSlice = createSlice({
  name: 'confirmationModal',
  initialState: initialState,
  reducers: {
    open: (state, { payload }) => {
      state.isOpened = true
      state.isDeclined = false
      state.isConfirmed = false

      if (payload?.title && payload?.title !== '') {
        state.title = payload.title
      }
      if (payload?.message && payload?.message !== '') {
        state.message = payload.message
      }
      state.isInput = payload.isInput
      state.inputLabel = payload.inputLabel
    },
    confirm: (state, { payload }) => {
      state.isConfirmed = true
      state.isOpened = false

      if (state.isInput) {
        state.inputValue = payload
      }
    },
    decline: (state) => {
      state.isDeclined = true
      state.isOpened = false
    },
  },
})

export const confirmationModalActions = confirmationModalSlice.actions

export const confirmationModalThunkActions = {
  open: createAsyncThunk('confirmationModal', async (payload, { extra, dispatch }) => {
    const store = extra.store

    dispatch(confirmationModalActions.open(payload))

    return new Promise((resolve) => {
      const unsubscribe = store.subscribe(() => {
        const state = store.getState()
        if (state.confirmationModal.isConfirmed) {
          unsubscribe()
          resolve({ isConfirmed: true, inputValue: state.confirmationModal.inputValue ?? '' })
        }
        if (state.confirmationModal.isDeclined) {
          unsubscribe()
          resolve({ isConfirmed: false })
        }
      })
    })
  }),
}

export default confirmationModalSlice.reducer

export const useConfirmationModalManagement = () => {
  const dispatch = useDispatch()
  const { isOpened, title, message, isInput, inputLabel } = useSelector((state) => state.confirmationModal)
  const open = async ({ title, message, isInput, inputLabel }) => {
    const { payload } = await dispatch(confirmationModalThunkActions.open({ title, message, isInput, inputLabel }))
    return payload
  }
  const confirm = (data) => {
    return dispatch(confirmationModalActions.confirm(data))
  }
  const decline = () => {
    return dispatch(confirmationModalActions.decline())
  }
  return {
    isOpened,
    title,
    isInput,
    inputLabel,
    message,
    open,
    confirm,
    decline,
  }
}
